const FutureOptionSection = () => {
  return (
    <section className="about about--style1 bg-color xts-section">
      <div className="container">
        <div className="about__wrapper">
          <div className="row gx-5 gy-4 gy-sm-0 align-items-center">
            <div className="col-lg-12">
              <div
                className="about__content"
                data-aos="fade-left"
                data-aos-duration="800"
              >
                <div className="section-header text-center mb-2">
                  <h2 className="text-uppercase">
                    Explore the World of Derivatives <br />
                    with <span className="style2">Asiatic Stock & Securities Ltd.</span>
                  </h2>
                  <p>
                    Unleashing the Power of Futures and Options for Your Financial
                    Success
                  </p>
                </div>
                <div className="about__content-inner">
                  <h4>Understanding Futures Trading</h4>
                  <p>
                    Futures and options, the dynamic duo of stock derivatives, take
                    center stage in the vibrant world of stock exchanges. These
                    agreements between parties allow traders to buy or sell a stock
                    asset at a predetermined price on a future date, providing a
                    strategic approach to hedge market risks.
                  </p>

                  <h4>Future Trading at a Glance</h4>
                  <p>
                    A futures contract is a commitment between a buyer and a seller.
                    The buyer agrees to buy, or the seller agrees to sell, a
                    specific number of shares or an index at a predetermined price
                    on a future date.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FutureOptionSection;
